import { render, staticRenderFns } from "./GvcForm.vue?vue&type=template&id=1eb096b2&"
import script from "./GvcForm.vue?vue&type=script&lang=js&"
export * from "./GvcForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports